import { ElMessage } from 'element-plus'

let lastAt = 0

/** Throttled error toast — replaces legacy unifiedErrorMessage / $toasts */
export default function sendError(error, type = 'error') {
  const now = Date.now()
  if (now - lastAt < 5000) return
  lastAt = now
  const msg = typeof error === 'string' ? error : error?.message || String(error)
  ElMessage({ message: msg, type: type === 'LimitFlow' ? 'warning' : 'error', duration: 4000 })
}
